"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.moveToXY = exports.moveToIJ = exports.create = exports.getAll = void 0;
var phaserUtil_sidecar_1 = require("@engine/phaserUtil-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var _offsets = [
    [0, -1],
    [1, 0],
    [0, 1],
    [-1, 0],
];
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function create() {
    var images = [];
    for (var i = 0; i < 4; i++) {
        var image = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipAbove, sprites_sidecar_1.sprites.voyTileIndicators[i]);
        images.push(image);
        image.tint = voyageColors_sidecar_1.voyageColors.yellow;
    }
    var obj = {
        id: -1,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        images: images,
        w: 32,
        h: 32,
        x: 0,
        y: 0,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function moveToIJ(obj, iij) {
    // obj.i = iij.i
    // obj.j = iij.j
    var t = voyageTilemap_sidecar_1.voyageTilemap.getSafe(iij.i, iij.j);
    if (t) {
        moveToXY(obj, t.x, t.y);
    }
}
exports.moveToIJ = moveToIJ;
function moveToXY(obj, x, y, w, h) {
    if (w === void 0) { w = 32; }
    if (h === void 0) { h = 32; }
    obj.x = x;
    obj.y = y;
    obj.w = w;
    obj.h = h;
    imports_1.l.forEach(obj.images, function (c, cIdx) {
        var os = _offsets[cIdx];
        c.x = x + (os[0] * w) / 2;
        c.y = y + (os[1] * h) / 2;
    });
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        phaserUtil_sidecar_1.phaserUtil.destroyAllImages(c.images);
    });
}
exports.removeDead = removeDead;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var et = common_sidecar_1.common.getElapsedTime();
    var scale = mathUtils_sidecar_1.mathUtils.sineLike(et, 2, 1, 2);
    var w = obj.w * scale;
    var h = obj.h * scale;
    imports_1.l.forEach(obj.images, function (c, cIdx) {
        var os = _offsets[cIdx];
        c.x = obj.x + (os[0] * w) / 2;
        c.y = obj.y + (os[1] * h) / 2;
    });
}
